// extracted by mini-css-extract-plugin
export default {"users":"UserList_users__OYScq"};